/* ═══ LA BOLSA — VERSIÓN SHOPIFY ═══════════════════════════════════════════
   Sustituye a `assets/bolsa.js` del sitio estático SOLO dentro del tema. El
   archivo del prototipo se queda como está: sirve para seguir trabajando en
   local sin tienda.

   🔴 QUÉ CAMBIA Y POR QUÉ NO SE PUDO HACER DESDE FUERA.
   Lo único que cambia es de dónde sale la verdad: antes `localStorage`, ahora
   el carrito del servidor. Pero `pintar()` vive DENTRO del cierre y llama a
   `leer()` por referencia capturada: sobreescribir `Bolsa.leer` desde otro
   archivo no cambia una sola línea de lo que se pinta. Por eso este archivo
   reemplaza al original en vez de parchearlo encima.

   🔴 Y POR QUÉ HAY UNA COPIA EN MEMORIA, SI EL OTRO ARCHIVO PRESUMÍA DE NO
   TENERLA. Porque `pintar()` es síncrono y el carrito de Shopify se pide por
   red. La copia NO es la verdad: es la última foto del servidor, y se vuelve a
   pedir después de cada cambio. La regla de fondo se respeta igual — nadie
   calcula el estado del carrito por su cuenta, solo lo repite.

   Lo que NO cambia, a propósito: el cajón, el paso de cantidad, el pulso del
   número, la trampa del foco, trabar el fondo sin brinco y el aviso entre
   pestañas. Todo eso es del sitio y ya estaba medido.                        */

window.Bolsa = (() => {
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const pesos = n => '$' + n.toLocaleString('es-MX');

  const cajon = $('#bolsa'), tapa = $('#bolsa-tapa');
  const lista = cajon && $('.lista', cajon);
  const totalEl = cajon && $('[data-total]', cajon);

  /* La última foto del carrito del servidor, más lo que el visitante acaba de
     tocar y todavía va en camino.

     🔴 1-OCT · POR QUÉ AHORA SE ADELANTA AL SERVIDOR. Antes cada «+» esperaba
     dos viajes (`change.js` y luego `cart.js`) y después redibujaba la lista
     ENTERA: todos los renglones volvían a hacer su entrada desde opacidad 0.
     En el teléfono eso se leía como «se trabó». Ahora el número cambia en el
     toque, la tienda confirma detrás, y la respuesta del servidor sigue
     mandando: si dice otra cosa (sin existencias, cupo lleno), se repinta con
     lo suyo y se avisa. */
  let carrito = { items: [], total_price: 0, item_count: 0 };
  let subio = null;

  /* Cambios que el visitante hizo y el servidor todavía no confirma. Mientras
     haya alguno, una respuesta del servidor NO pisa la pantalla: traería una
     foto de antes del último toque y el número regresaría un paso. */
  const objetivo = new Map();   // clave → cantidad que se quiere
  const relojes  = new Map();   // clave → espera antes de mandar
  let enVuelo = 0;
  let cola = Promise.resolve();
  const ocupado = () => enVuelo > 0 || relojes.size > 0;
  const enCola = tarea => (cola = cola.then(tarea, tarea));

  /* Shopify da los precios en centavos y titula «Default Title» la variante
     única. Las dos cosas se traducen aquí y no en `pintar`, para que el resto
     del archivo siga hablando el idioma del sitio. */
  const aPieza = i => ({
    clave: i.key,
    nombre: i.product_title,
    variante: (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '',
    precio: i.final_price / 100,
    q: i.quantity,
    img: i.image || '',
    provisional: !!i._provisional
  });

  const leer = () => carrito.items.map(aPieza);

  /* Rehace las cuentas de la copia local después de un cambio adelantado. */
  function recontar(){
    carrito.items.forEach(i => { i.final_line_price = i.final_price * i.quantity; });
    carrito.total_price = carrito.items.reduce((a, i) => a + i.final_line_price, 0);
    carrito.item_count  = carrito.items.reduce((a, i) => a + i.quantity, 0);
  }

  function ponerLocal(clave, q){
    const i = carrito.items.findIndex(x => x.key === clave);
    if (i < 0) return;
    if (q <= 0) carrito.items.splice(i, 1);
    else carrito.items[i].quantity = q;
    recontar();
  }

  /* Adopta la respuesta del servidor. Un renglón provisional («agregando»)
     hereda la clave real de su variante, así el MISMO nodo se queda en
     pantalla y no hay un renglón que se va y otro que entra. */
  function adoptar(nuevo){
    if (!nuevo || !Array.isArray(nuevo.items)) return;
    if (lista) $$('.linea[data-clave^="tmp-"]', lista).forEach(n => {
      const real = nuevo.items.find(i => 'tmp-' + i.variant_id === n.dataset.clave);
      if (real) n.dataset.clave = real.key;
    });
    carrito = nuevo;
    pintar();
  }

  async function refrescar(){
    try {
      const r = await fetch('/cart.js', { headers:{ 'Accept':'application/json' }});
      if (r.ok){
        const nuevo = await r.json();
        if (!ocupado()) { adoptar(nuevo); return; }
      }
    } catch {}
    pintar();
  }

  /* ── el aviso ───────────────────────────────────────────────────────────
     Antes, pedir más de lo que hay no decía nada: el servidor respondía 422 y
     el número simplemente no subía. Ahora se dice con las palabras de Shopify
     (que ya vienen en español y con la cantidad). */
  let avisoEl = null, avisoReloj = 0;
  function avisar(texto){
    if (!cajon || !texto) return;
    if (!avisoEl){
      avisoEl = document.createElement('p');
      avisoEl.className = 'aviso-bolsa';
      avisoEl.setAttribute('role', 'status');
      lista.before(avisoEl);
    }
    avisoEl.textContent = texto;
    avisoEl.hidden = false;
    clearTimeout(avisoReloj);
    avisoReloj = setTimeout(() => { avisoEl.hidden = true; }, 5000);
  }
  async function motivo(r){
    try { const d = await r.json(); return d.description || d.message || ''; } catch { return ''; }
  }

  /* ── pintar sin volver a dibujar todo ───────────────────────────────────
     Los renglones se REUSAN por su clave: el que ya estaba sólo cambia su
     número y su texto, y únicamente el que llega nuevo hace su entrada. */
  function crearLinea(){
    const d = document.createElement('div');
    d.className = 'linea';
    d.innerHTML = `<img src="" alt="" loading="lazy">
      <div><b></b><small></small></div>
      <div class="paso-q">
        <button type="button" class="menos" aria-label="Quitar uno">&minus;</button>
        <span class="q"></span>
        <button type="button" class="mas" aria-label="Agregar uno">+</button>
      </div>`;
    return d;
  }

  function llenar(d, i){
    d.dataset.clave = i.clave;
    /* La foto del carrito de Shopify viene a tamaño original. Se pide a 160
       de ancho: el renglón mide 64 y a 2× son 128. Servir el original aquí
       son cientos de KB por renglón que nadie ve. La provisional ya viene
       chica desde la ficha y se usa tal cual. */
    const src = !i.img ? '' : i.provisional ? i.img
      : i.img.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
    const img = $('img', d);
    if (src && img.getAttribute('src') !== src) img.src = src;
    $('b', d).textContent = i.nombre;
    $('small', d).textContent = [i.variante, pesos(i.precio)].filter(Boolean).join(' · ');
    const q = $('.q', d);
    if (q.textContent !== String(i.q)) q.textContent = i.q;
    /* El botón de quitar dice QUÉ quita: un «−» solo obliga a mirar el
       renglón de al lado, y un lector de pantalla no tiene ese «al lado». */
    const menos = $('.menos', d), mas = $('.mas', d);
    menos.setAttribute('aria-label',
      i.q === 1 ? `Quitar ${i.nombre} de la bolsa` : `Quitar un ${i.nombre}`);
    mas.setAttribute('aria-label', `Agregar otro ${i.nombre}`);
    menos.dataset.clave = mas.dataset.clave = i.clave;
    /* Mientras el servidor no le da clave real, el renglón no se puede tocar:
       un «+» sobre una clave inventada no tendría a quién cambiar. */
    menos.disabled = mas.disabled = i.provisional;
    d.toggleAttribute('data-provisional', i.provisional);
    /* El destello de «subió» se rearma: una animación no se repite sola. */
    if (i.clave === subio){
      d.removeAttribute('data-subio'); void d.offsetWidth; d.setAttribute('data-subio', '');
    }
  }

  function pintar(){
    const l = leer();
    const piezas = l.reduce((a, i) => a + i.q, 0);
    $$('.carro').forEach(a => {
      a.setAttribute('aria-label', `Carrito, ${piezas} artículo${piezas === 1 ? '' : 's'}`);
      a.toggleAttribute('data-vacia', piezas === 0);
    });
    /* El número AVISA cuando cambia: es lo único que se mueve en el menú al
       agregar. Solo si CAMBIÓ —repintar no es un evento— y rearmando la clase,
       porque una animación de keyframes no se reinicia sola. */
    $$('[data-cuenta]').forEach(n => {
      const texto = `(${piezas})`;
      if (n.textContent === texto) return;
      n.textContent = texto;
      n.classList.remove('pulso');
      void n.offsetWidth;
      n.classList.add('pulso');
    });

    if (!lista) return;
    const vacia = $('.vacia', lista);
    if (!l.length){
      $$('.linea', lista).forEach(n => n.remove());
      if (!vacia) lista.innerHTML = '<p class="vacia">Todavía no has agregado nada.</p>';
    } else if (vacia) vacia.remove();

    const previas = new Map($$('.linea', lista).map(n => [n.dataset.clave, n]));
    let nuevas = 0;
    l.forEach((i, n) => {
      let d = previas.get(i.clave);
      if (d) previas.delete(i.clave);
      else { d = crearLinea(); d.style.setProperty('--i', nuevas++); }
      llenar(d, i);
      /* Sólo se mueve si está fuera de lugar: mover un nodo lo saca y lo
         vuelve a meter, y eso reinicia su animación de entrada. */
      if (lista.children[n] !== d) lista.insertBefore(d, lista.children[n] || null);
    });
    previas.forEach(n => n.remove());

    if (totalEl) totalEl.textContent = pesos(carrito.total_price / 100);
    /* Con la bolsa vacía se apagan LOS DOS: el pagar y el «ver la bolsa
       completa». Un enlace a una página vacía no es una salida, es un callejón. */
    $$('footer .btn, footer .ver-bolsa', cajon || document)
      .forEach(el => el.toggleAttribute('data-apagado', l.length === 0));
  }

  /* `pieza.clave` viene de la ficha como `sku|<id de variante>`. El id real es
     lo de después de la barra; si no hay barra, la ficha ya mandó el id solo. */
  const idDe = pieza => {
    const v = String(pieza.clave || '').split('|').pop();
    return /^\d+$/.test(v) ? v : null;
  };

  /* Acepta una pieza o varias.

     🔴 Y TIENE QUE ACEPTAR VARIAS. La ficha agrega el producto y, si está
     marcado, el complemento — la pluma que se ofrece dentro. Llamando dos veces
     seguidas salían **dos POST en paralelo** contra el mismo carrito y el
     segundo se perdía: comprobado, entraba la Planner y la pluma no. `/cart/add.js`
     acepta una lista, así que los dos renglones viajan en UNA petición y el
     servidor los mete juntos.

     La pieza se pinta ANTES de mandarla (la ficha abre el cajón en el mismo
     clic, y antes se abría vacío o con lo de antes). Va marcada como
     provisional hasta que el servidor la acepta; si la rechaza, se va. */
  function agregar(piezas){
    const lote = (Array.isArray(piezas) ? piezas : [piezas]).filter(Boolean);
    const items = [];
    for (const pieza of lote){
      const id = idDe(pieza);
      /* 🔴 SIN ID NO SE INVENTA UN RENGLÓN. El prototipo podía guardar cualquier
         cosa en el navegador; aquí un renglón que el servidor no conoce es una
         bolsa que miente y un pago que falla. Se avisa y no se agrega. */
      if (!id) { console.warn('Bolsa: la pieza no trae id de variante', pieza); continue; }
      items.push({ id: Number(id), quantity: 1 });

      const ya = carrito.items.find(i => i.variant_id === Number(id));
      if (ya) { ya.quantity += 1; subio = ya.key; }
      else {
        const c = Math.round((Number(pieza.precio) || 0) * 100);
        carrito.items.unshift({ key: 'tmp-' + id, variant_id: Number(id),
          product_title: pieza.nombre || '', variant_title: pieza.variante || '',
          final_price: c, quantity: 1, image: pieza.img || '', _provisional: true });
      }
    }
    if (!items.length) return Promise.resolve();
    recontar();
    pintar();

    enVuelo++;
    return enCola(async () => {
      try {
        const r = await fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ items })
        });
        if (!r.ok) avisar(await motivo(r) || 'No se pudo agregar. Intenta de nuevo.');
        else {
          const datos = await r.json();
          subio = (datos.items && datos.items[0] && datos.items[0].key) || subio;
        }
      } catch (e) { avisar('No se pudo agregar. Revisa tu conexión e intenta de nuevo.'); }
      enVuelo--;
      await refrescar();
      subio = null;
    });
  }

  /* `−` en el último ejemplar quita el renglón, como Apple e IKEA. Se manda la
     cantidad ABSOLUTA porque `/cart/change.js` es un `set`, no un `add`.

     Tres toques rápidos en «+» son UNA petición con la cantidad final, no
     tres: se espera un respiro corto después del último toque. */
  function cambiar(clave, delta){
    const actual = carrito.items.find(i => i.key === clave);
    if (!actual || actual._provisional) return;
    const q = Math.max(0, actual.quantity + delta);
    if (q === actual.quantity) return;
    ponerLocal(clave, q);
    pintar();
    objetivo.set(clave, q);
    clearTimeout(relojes.get(clave));
    relojes.set(clave, setTimeout(() => {
      relojes.delete(clave);
      const meta = objetivo.get(clave);
      objetivo.delete(clave);
      enVuelo++;
      enCola(async () => {
        try {
          const r = await fetch('/cart/change.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ id: clave, quantity: meta })
          });
          enVuelo--;
          if (!r.ok){ avisar(await motivo(r) || 'No se pudo cambiar la cantidad.'); await refrescar(); return; }
          /* `change.js` ya devuelve el carrito completo: no hace falta un
             segundo viaje a `cart.js`. */
          const nuevo = await r.json();
          if (!ocupado()) adoptar(nuevo);
        } catch (e) {
          enVuelo--;
          avisar('No se pudo cambiar la cantidad. Revisa tu conexión.');
          await refrescar();
        }
      });
    }, 250));
  }

  /* ── abrir y cerrar ─────────────────────────────────────────────────────── */
  let quienAbrio = null;
  let yGuardada = 0;

  /* Trabar el fondo tiene TRES fallos, no uno: en táctil el arrastre sigue
     moviendo la página, quitar la barra de desplazamiento hace brincar el sitio
     15 px, y Lenis sigue corriendo aunque el body esté fijo. Se congela la
     posición, `scrollbar-gutter:stable` reserva el hueco (en la hoja) y se
     enciende la MISMA marca que ya vigila `suave.js` — dos maneras de decir
     «está trabado» es como se desincronizan. */
  function trabar(si){
    const d = document.documentElement;
    document.body.classList.toggle('trabado', si);
    if (si){
      yGuardada = window.scrollY;
      d.style.setProperty('--y-trabada', `-${yGuardada}px`);
      d.classList.add('trabada');
    } else if (d.classList.contains('trabada')) {
      d.classList.remove('trabada');
      /* `instant`: devolver la posición no es un viaje, es no haberse movido. */
      window.scrollTo({ top: yGuardada, behavior: 'instant' });
    }
  }

  const abrir = () => {
    if (!cajon) return;
    quienAbrio = document.activeElement;
    trabar(true);
    cajon.removeAttribute('data-saliendo'); tapa.removeAttribute('data-saliendo');
    cajon.setAttribute('data-abierta',''); tapa.setAttribute('data-abierta','');
    cajon.removeAttribute('aria-hidden');
    $('.cerrar-bolsa', cajon).focus();
  };
  /* Se abre despacio porque el visitante está DECIDIENDO mirar; se cierra
     rápido porque ya decidió irse y el sistema solo obedece. */
  const cerrar = () => {
    if (!cajon) return;
    trabar(false);
    if (quienAbrio && quienAbrio.isConnected) quienAbrio.focus();
    cajon.setAttribute('data-saliendo',''); tapa.setAttribute('data-saliendo','');
    cajon.removeAttribute('data-abierta'); tapa.removeAttribute('data-abierta');
    cajon.setAttribute('aria-hidden','true');
  };

  if (cajon){
    $('.cerrar-bolsa', cajon).addEventListener('click', cerrar);
    tapa.addEventListener('click', cerrar);

    /* Un solo oyente para los botones de cantidad de todos los renglones: la
       lista se reconstruye en cada pintada y los oyentes por botón se irían
       con ella. */
    lista.addEventListener('click', e => {
      const b = e.target.closest('button[data-clave]');
      if (!b) return;
      cambiar(b.dataset.clave, b.classList.contains('mas') ? 1 : -1);
    });

    /* El foco se queda dentro. Escape cierra; con Tab se salía del cajón y se
       seguía tabulando por la página tapada por la cortina: el anillo
       desaparecía y no había forma de saber dónde estaba. En una caja de
       compra eso es perder al comprador. */
    const FOCABLES = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
    addEventListener('keydown', e => {
      if (!cajon.hasAttribute('data-abierta')) return;
      if (e.key === 'Escape') { cerrar(); return; }
      if (e.key !== 'Tab') return;
      const f = $$(FOCABLES, cajon).filter(n => n.offsetParent !== null);
      if (!f.length) return;
      const primero = f[0], ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primero){ e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo){ e.preventDefault(); primero.focus(); }
    });

    $$('.carro').forEach(a => a.addEventListener('click', e => {
      e.preventDefault();
      if (a.hasAttribute('data-vacia')) return;
      abrir();
    }));
  }

  /* Al volver con el botón «atrás» la página puede salir de la caché de ida y
     vuelta con la bolsa de hace tres pantallas. Se vuelve a pedir. */
  addEventListener('pageshow', ev => { if (ev.persisted) refrescar(); });

  /* Otra pestaña compró o quitó algo. El carrito de Shopify es de la SESIÓN, no
     de la pestaña, así que las dos tienen que enseñar lo mismo. Aquí no hay
     evento `storage` que escuchar —nadie escribe en el navegador—, así que se
     refresca al volver a la pestaña. */
  addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refrescar();
  });

  refrescar();
  return { leer, agregar, cambiar, pintar, abrir, cerrar, trabar, refrescar };
})();
